module.exports = __webpack_public_path__ + "img/toggle-left-off.b4d03e43.svg";